<ts-panel
  [loading]="loadingChart()"
  [title]="panelVisualizationConfig?.title || panelDef?.title"
  [headerColor]="panelVisualizationConfig?.headerColor"
  [displayPanelOptions]="hasPanelData && canEditPanelDef"
  (panelOptionsClicked)="openPanelCreationDialog(panelVisualizationConfig)"
>
  <div
    ts-panel-content
    class="flex flex-col justify-center items-center p-2"
    [ngClass]="isOverviewTab ? 'h-100' : 'h-full'"
  >
    @if (hasPanelData && chartPanelDataSource()) {
      <chart-renderer
        class="h-full w-full"
        [data]="{ visualizationConfig: panelDef?.meta, dataSource: chartPanelDataSource() }"
      ></chart-renderer>
    } @else {
      <ts-empty-state
        icon="ts_table"
        class="py-8"
        title="Create a new chart"
        [authorizeButton]="canEditPanelDef"
        [buttonConfig]="createNewChartConfig"
      ></ts-empty-state>
    }
  </div>
</ts-panel>
